import { HttpErrorResponse } from "@angular/common/http";
import { Component, inject } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { filter, tap } from "rxjs/operators";

import { AuthModel } from "@intocare/auth-data";
import { SnackbarService } from "@intocare/ui";

@Component({
	selector: "ic-select-organisation",
	templateUrl: "./select-organisation.component.html",
	styleUrls: ["./select-organisation.component.scss"],
	standalone: false,
})
export class SelectOrganisationComponent {
	private auth = inject(AuthModel);
	private router = inject(Router);
	private snackbar = inject(SnackbarService);

	private loadingSubject$ = new BehaviorSubject(false);
	errorLabel$ = new BehaviorSubject<string>("");
	private wrongOrganisationSubject$ = new BehaviorSubject(false);
	loading$ = this.loadingSubject$.asObservable();
	wrongOrganisation$ = this.wrongOrganisationSubject$.asObservable();
	error$ = this.auth.errorMessage$.pipe(
		filter<string>(Boolean),
		tap(() => {
			this.loadingSubject$.next(false);
		}),
	);
	inactivity = this.auth.inactivity;
	currentOrganisation = "";

	selectOrganisation(organisation: string) {
		this.currentOrganisation = organisation;
		this.loadingSubject$.next(true);
		this.errorLabel$.next("");
		this.auth.bootstrapUserPool(organisation, { forceRefresh: true }).subscribe({
			next: (config) => {
				this.wrongOrganisationSubject$.next(false);
				this.loadingSubject$.next(false);

				this.router.navigate(
					[organisation.split(".").join("/"), config.hostedUiUri ? "sign-in" : "sign-in-with-username"],
					{ queryParamsHandling: "preserve" },
				);
			},
			error: (err: unknown) => {
				this.loadingSubject$.next(false);

				if (
					(err instanceof HttpErrorResponse && err.status === 404)
					|| (err instanceof HttpErrorResponse && err.status === 400)
				) {
					this.errorLabel$.next("auth.errors.wrong-organisation");
					this.wrongOrganisationSubject$.next(true);
				} else {
					this.snackbar.show({ text: "auth.errors.unknown", error: true });
				}
			},
			complete: () => {
				this.loadingSubject$.next(false);
			},
		});
	}
}
